import { useTranslation } from 'react-i18next';
import type { Plan } from '../types';

interface PlanBadgeProps {
  plan: Plan;
  size?: 'sm' | 'md';
}

const PLAN_STYLES: Record<Plan, { bg: string; text: string; border: string; dot: string }> = {
  free: {
    bg: 'bg-gray-100',
    text: 'text-gray-600',
    border: 'border-gray-200',
    dot: 'bg-gray-400'
  },
  mid: {
    bg: 'bg-blue-50',
    text: 'text-blue-700',
    border: 'border-blue-200',
    dot: 'bg-blue-500'
  },
  pro_plus: {
    bg: 'bg-brand-50',
    text: 'text-brand-700',
    border: 'border-brand-200',
    dot: 'bg-brand-500'
  },
  top: {
    bg: 'bg-primary-50',
    text: 'text-primary-700',
    border: 'border-primary-200',
    dot: 'bg-primary-500'
  },
  enterprise: {
    bg: 'bg-gray-900/5',
    text: 'text-gray-900',
    border: 'border-gray-900/20',
    dot: 'bg-gray-900'
  }
};

export function PlanBadge({ plan, size = 'sm' }: PlanBadgeProps) {
  const { t } = useTranslation();
  const styles = PLAN_STYLES[plan];
  const sizeClasses = size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-3 py-1 text-sm';

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border font-medium ${styles.bg} ${styles.text} ${styles.border} ${sizeClasses}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${styles.dot}`} />
      {t(`plans.${plan}`)}
    </span>
  );
}
